module.exports = __webpack_public_path__ + "img/img_3.0b1acbcf.png";